import Stack from '@mui/material/Stack';
import { useTheme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';

import type { ImageCarouselSidebarProps } from '../ImageCarousel/ImageCarousel';

export const ImageCarouselSidebar = ({ label, children }: ImageCarouselSidebarProps) => {
  const theme = useTheme();
  return (
    <Stack
      sx={{
        height: '100%',
        backgroundColor: theme.palette.background.default,
      }}
    >
      <Typography
        variant="h5"
        sx={{
          fontWeight: 'bold',
          paddingX: 4,
          paddingY: 2,
        }}
      >
        {label}
      </Typography>
      {children}
    </Stack>
  );
};
